import React from 'react';
import { Control, Controller } from 'react-hook-form';
import Checkbox from '../../../checkbox/checkbox';
import Typography from '../../../typography/typography';
import { CheckboxProps, Stack, StackProps } from '@mui/material';
import { useLanguage } from '@erpsquad/common/runtime';

interface IDynamicCheckbox {
	formControl: Control<any>;
	fieldArrayName: string;
	name: string;
	label?: string;
	position?: number;
	disabled?: boolean;
	titlePosition?: 'start' | 'end';
	typeOfField?: string;
	title: string;
	titleColor?: string; // New prop for title color
	checkboxProps?: CheckboxProps;
	stackProps?: StackProps;
}

const DynamicCheckBox: React.FC<IDynamicCheckbox> = ({
	formControl,
	fieldArrayName,
	name,
	label,
	position,
	disabled,
	titlePosition = 'end',
	title,
	titleColor = 'theme.secondary.800', // Default color
	checkboxProps,
	stackProps,
}) => {
	const {isRtl}=useLanguage();
	return (
		<Controller
			control={formControl}
			name={`${fieldArrayName}.${name}`}
			render={({ field }) => (
				<>
					{label && (
						<Typography
							type='s5'
							weight='medium'
							color='theme.secondary.800'
							data-position={position}
							sx={{ mb: 0.5 }}>
							{label}
						</Typography>
					)}

					<Stack direction='row' spacing={isRtl?'':0.25} alignItems='center' {...stackProps}>
						{titlePosition === 'start' && (
							<Typography
								type='s4'
								weight='medium'
								color={titleColor}> {/* Use titleColor prop here */}
								{title}
							</Typography>
						)}
						<Checkbox
							checked={Boolean(field.value)}
							onChange={field.onChange}
							disabled={disabled}
							size='small'
							sx={{ m: 1 }}
							{...checkboxProps}
						/>
						{titlePosition === 'end' && (
							<Typography
								type='s4'
								weight='medium'
								color={titleColor}> {/* Use titleColor prop here */}
								{title}
							</Typography>
						)}
					</Stack>
				</>
			)}
		/>
	);
};

export default DynamicCheckBox;